import { Box } from "@material-ui/core";
import { memo } from "react";

import { FileRemoveActionWithParam, Images } from "../../types";
import { SinglePreview } from "../SinglePreview";

import styles from "./MultiPreview.module.scss";

type MultiPreviewProps = {
  readonly images: Images;
  readonly onFileRemove: FileRemoveActionWithParam;
  readonly readOnly?: boolean;
};

export const MultiPreview = memo<MultiPreviewProps>(
  ({ images, onFileRemove, readOnly = false }) => {
    const previews = [];

    for (const [key, image] of Object.entries(images)) {
      previews.push(
        <SinglePreview
          key={key}
          image={image}
          readOnly={readOnly}
          onFileRemove={() => onFileRemove(key)}
        />
      );
    }

    return <Box className={styles.container}>{previews}</Box>;
  }
);
